// extracted by mini-css-extract-plugin
module.exports = {"one-column":"CheckboxFiltersOptions_one-column__1uAZE","two-columns":"CheckboxFiltersOptions_two-columns__1sWwF"};